var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#E5122E",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 6h-8.36C28.8 3.68 26.6 2 24 2c-2.6 0-4.8 1.68-5.64 4H10c-.28 0-.54.02-.8.08-.78.16-1.48.56-2.02 1.1-.36.36-.66.8-.86 1.28-.2.46-.32.98-.32 1.54v28c0 .54.12 1.08.32 1.56s.5.9.86 1.28c.54.54 1.24.94 2.02 1.1.26.04.52.06.8.06h28c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4ZM20.6 29.76c-.78.78-2.06.78-2.84 0l-4.34-4.34c-.78-.78-.78-2.04 0-2.82l4.34-4.34c.78-.78 2.06-.78 2.84 0 .78.78.78 2.04 0 2.82L17.66 24l2.92 2.92c.78.78.8 2.06.02 2.84ZM24 8.5c-.82 0-1.5-.68-1.5-1.5s.68-1.5 1.5-1.5 1.5.68 1.5 1.5-.68 1.5-1.5 1.5Zm3.4 21.26c-.78-.78-.78-2.04 0-2.82L30.34 24l-2.94-2.94c-.78-.78-.78-2.04 0-2.82.78-.78 2.06-.78 2.84 0l4.34 4.34c.78.78.78 2.04 0 2.82l-4.34 4.34c-.78.8-2.06.8-2.84.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnd);
export default __webpack_public_path__ + "static/media/hnd.4baca555b27e34f45ff76b86b06ed97a.svg";
export { ForwardRef as ReactComponent };